import { Circle, CircleDot, CheckCircle2, Lock } from "lucide-react";

const STATUS_ICON = {
  complete: CheckCircle2,
  partial: CircleDot,
  incomplete: Circle,
};

/**
 * Vertical step navigator — Brief 2 §5B.
 * Steps 1–6 are freely clickable; step 7 is locked until 1–5 are all complete.
 */
export default function StepNav({ steps, current, stepStatus, onSelect, submitGated }) {
  return (
    <nav data-testid="onboarding-step-nav" className="flex md:flex-col gap-1 overflow-x-auto md:overflow-visible -mx-1 px-1">
      {steps.map(({ num, title }) => {
        const status = stepStatus[String(num)] || "incomplete";
        const Icon = STATUS_ICON[status] || Circle;
        const isCurrent = current === num;
        const isStep7 = num === 7;
        const locked = isStep7 && submitGated;

        return (
          <button
            key={num}
            type="button"
            onClick={() => !locked && onSelect(num)}
            disabled={locked}
            data-testid={`onboarding-step-${num}-nav`}
            className={`group min-w-[180px] md:min-w-0 text-left rounded-xl px-3 py-2.5 transition-colors flex items-start gap-2.5 ${
              isCurrent
                ? "bg-white/[0.06] border border-white/[0.08]"
                : "border border-transparent hover:bg-white/[0.03]"
            } ${locked ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            {locked ? (
              <Lock className="h-3.5 w-3.5 mt-[3px] text-zinc-500 shrink-0" />
            ) : (
              <Icon
                className={`h-3.5 w-3.5 mt-[3px] shrink-0 ${
                  status === "complete"
                    ? "text-emerald-300"
                    : status === "partial"
                    ? "text-amber-300"
                    : "text-zinc-500"
                }`}
              />
            )}
            <div className="min-w-0">
              <div className="text-[10.5px] uppercase tracking-[0.2em] text-zinc-500 mb-0.5">
                Step {num} of 7
              </div>
              <div
                className={`text-[13.5px] truncate ${
                  isCurrent ? "text-white font-medium" : "text-zinc-300"
                }`}
              >
                {title}
              </div>
              <div
                data-testid={`onboarding-step-${num}-status`}
                className={`mt-0.5 text-[10.5px] uppercase tracking-[0.18em] ${
                  status === "complete"
                    ? "text-emerald-300"
                    : status === "partial"
                    ? "text-amber-300"
                    : "text-zinc-500"
                }`}
              >
                {locked ? "Locked" : status}
              </div>
            </div>
          </button>
        );
      })}
    </nav>
  );
}
